<template>
  <div
    class="b2b-details-box"
    :class="open_accor == true ? 'mobile-sidebar-card' : ''"
  >
    <div
      id="payment_box"
      v-if="
        selected.filter((element) => element.invoice_outstanding > 0).length > 0
      "
    >
      <div class="container d-flex justify-content-end align-items-center">
        <div class="text-right sel-box px-3">
          <div class="min-title">Sélection</div>
          <div class="sel-value">
            {{
              selected.filter((element) => element.invoice_outstanding > 0)
                .length
            }}
          </div>
        </div>
        <div class="text-right sel-box px-3">
          <div class="min-title">Montant Total</div>
          <div class="sel-value">{{ getTotalAmount }} FCFA</div>
        </div>
        <div class="px-3">
          <button class="btn btn-primary" @click="payProcess()">
            <span>Payer</span>
          </button>
        </div>
      </div>
    </div>
    <div class="b2b-details-box-header" @click="developpBlock">
      <div class="d-flex justify-content-between">
        <div>
          <h2 class="font-bold mb-0">Liste des factures</h2>
          <p class="m-0 font-12" style="" v-show="open_accor == false">
            Veuillez cocher les factures que vous souhaitez payer
          </p>
        </div>
        <div
          v-if="open_accor == true"
          @click="developpBlock"
          class="
            chevron-parent
            d-flex
            align-items-center
            justify-content-center
          "
        >
          <i
            @click="developpBlock"
            class="mdi mdi-chevron-right"
            style="font-size: 24px !important"
          ></i>
        </div>
        <div
          v-if="open_accor == false && checkScreen === 'mobile'"
          @click="developpBlock"
          class="
            chevron-parent
            d-flex
            align-items-center
            justify-content-center
          "
        >
          <i
            @click="developpBlock"
            class="mdi mdi-chevron-down"
            style="font-size: 24px !important"
          ></i>
        </div>
      </div>
    </div>
    <div class="" v-show="open_accor == false">
      <Skeleton
        :number="5"
        size="36px"
        spacing_bottom="mb-3"
        v-if="on_loading == true"
      />
      <div v-else>
        <EmptyState
          :message="'Aucune facture disponible'"
          v-if="facturesList.length == 0"
        />
        <div class="py-3" v-else>
          <div
            class="d-flex justify-content-end mb-2"
            :style="
              selected.filter((element) => element.invoice_outstanding > 0)
                .length === 0
                ? 'visibility: hidden'
                : ''
            "
            v-show="
              selected.filter((element) => element.invoice_outstanding > 0)
                .length > 0
            "
          ></div>
          <b-table
            striped
            :stacked="checkScreen == 'mobile'"
            responsive
            :fields="fields"
            :items="facturesList"
            :select-mode="'multi'"
            ref="selectableTable"
            selectable
            @row-selected="onRowSelected"
          >
            <template #head(selected)>
              <div class="form-check p-0">
                <input
                  id="invoice_checkbox_head"
                  class="styled-checkbox"
                  :checked="checkedAll"
                  @change="selectAll()"
                  type="checkbox"
                />
                <label for="invoice_checkbox_head"></label>
              </div>
            </template>
            <template #cell(selected)="row" class="w-100 position-relative">
              <template v-if="row.rowSelected == true">
                <div class="form-check p-0">
                  <input
                    :id="'invoice_checkbox' + row.index"
                    class="styled-checkbox"
                    type="checkbox"
                    :checked="
                      row.rowSelected && row.item.invoice_outstanding > 0
                    "
                    @change="
                      selectOne(
                        row.index,
                        row.rowSelected,
                        row.item.invoice_outstanding
                      )
                    "
                    :disabled="row.item.invoice_outstanding <= 0"
                  />
                  <label :for="'invoice_checkbox' + row.index"></label>
                </div>
              </template>
              <template v-if="row.rowSelected == false">
                <div class="form-check p-0">
                  <input
                    :id="'invoice_checkbox' + row.index"
                    class="styled-checkbox"
                    type="checkbox"
                    @change="
                      selectOne(
                        row.index,
                        row.rowSelected,
                        row.item.invoice_outstanding
                      )
                    "
                    :disabled="row.item.invoice_outstanding <= 0"
                  />
                  <label :for="'invoice_checkbox' + row.index"></label>
                </div>
              </template>
            </template>
            <template #cell(invoice_status)="data">
              <div class="d-flex justify-content-center text-center">
                <div>
                  <div>
                    <b-badge
                      :class="
                        data.item.invoice_outstanding > 0 ? 'unpaid' : 'paid'
                      "
                      >{{
                        formatPaymentStatus(data.item.invoice_outstanding)
                      }}</b-badge
                    >
                  </div>
                  <!-- <a
                    v-if="data.item.invoice_outstanding > 0"
                    @click.prevent="
                      open_modal('pay_business_facture' + data.item.sno)
                    "
                    class="pay-link"
                    >Payer</a
                  > -->
                </div>
              </div>
              <!-- <PaymentProcess
                :facture_data="data.item"
                :id="'pay_business_facture' + data.index"
              /> -->
            </template>
            <template #cell(invoice_outstanding)="data">
              {{ data.item.invoice_outstanding + " FCFA" }}
            </template>
            <template #cell(invoice_amount)="data">
              {{ data.item.invoice_amount + " FCFA" }}
            </template>
          </b-table>
          <MultiplePaymentProcess
            :id="'pay_multiple_factures'"
            :factures_datas="
              selected.filter((element) => element.invoice_outstanding > 0)
            "
          />
          <PaymentProcess
            :facture_data="
              this.selected.filter(
                (element) => element.invoice_outstanding > 0
              )[0]
            "
            :id="'pay_business_facture'"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Skeleton from "@/components/business/skeleton";
import EmptyState from "@/components/business/emptyState";
import PaymentProcess from "@/components/business/utils/PaymentProcess";
import MultiplePaymentProcess from "@/components/business/utils/MultiplePaymentProcess";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import { subscriber } from "@/services/";
import _ from "lodash";
import { is } from "vee-validate/dist/rules";
export default {
  components: {
    Skeleton,
    EmptyState,
    PaymentProcess,
    MultiplePaymentProcess,
  },
  data: function () {
    return {
      on_loading: true,
      facturesList: [],
      fields: [
        {
          key: "selected",
          label: "",
        },
        {
          key: "invoice_number",
          label: "Référence",
        },
        {
          key: "invoice_date",
          label: "Période",
        },
        // {
        //   key: "invoice_due_date",
        //   label: "Date limite",
        // },
        {
          key: "invoice_amount",
          label: "Montant",
        },
        {
          key: "invoice_outstanding",
          label: "Reste",
        },
        {
          key: "invoice_status",
          label: "Statut",
        },
      ],
      selected: [],
      open_accor: false,
    };
  },
  created: async function () {
    this.loadLastBills();
    if (this.checkScreen === "mobile") {
      this.open_accor = true;
    }
  },
  computed: {
    getTotalAmount() {
      let rest = this.selected.filter(
        (element) => element.invoice_outstanding > 0
      );
      let acc = rest.reduce((accumulator, element) => {
        return accumulator + element.invoice_outstanding;
      }, 0);
      return acc;
    },
    checkedAll() {
      if (
        this.selected.filter((element) => element.invoice_outstanding > 0)
          .length ===
          this.facturesList.filter((element) => element.invoice_outstanding > 0)
            .length &&
        this.selected.length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    haveMinOneUnpaid() {
      const index = this.facturesList.findIndex(
        (element) => element.invoice_outstanding > 0
      );
      if (index > -1) {
        return true;
      } else {
        return false;
      }
    },
    checkScreen() {
      if (window.screen.availWidth >= 625) {
        return "laptop";
      } else {
        return "mobile";
      }
    },
  },
  methods: {
    developpBlock() {
      if (this.checkScreen == "mobile") {
        this.open_accor = !this.open_accor;
      }
    },
    selectOne(index, isSelected, amount) {
      if (amount >= 0) {
        if (isSelected == true) {
          this.$refs.selectableTable.unselectRow(index);
        } else {
          this.$refs.selectableTable.selectRow(index);
        }
      } else {
        return;
      }
    },
    onRowSelected(items) {
      this.selected = items;
    },
    selectAll() {
      if (
        this.selected.filter((element) => element.invoice_outstanding > 0)
          .length ===
        this.facturesList.filter((element) => element.invoice_outstanding > 0)
          .length
      ) {
        this.$refs.selectableTable.clearSelected();
      } else {
        this.$refs.selectableTable.selectAllRows();
      }
    },
    async loadRequest() {
      await subscriber.get_last_bills().then((response) => {
        this.on_loading = false;
        if (_.isUndefined(response.error)) {
          if (!_.isNil(response.api_output)) {
            if (!_.isNil(response.api_output.account_invoices)) {
              if (
                !_.isNil(response.api_output.account_invoices.invoice_details)
              ) {
                this.facturesList =
                  response.api_output.account_invoices.invoice_details;
                this.facturesList = this.facturesList.map((element) => {
                  return {
                    ...element,
                    invoice_amount: parseInt(element.invoice_amount),
                    invoice_outstanding: parseInt(
                      element.invoice_outstanding.replace("XOF", "").trim()
                    ),
                  };
                });
              }
            }
          }
        } else {
          return;
        }
      });
    },
    async loadLastBills() {
      this.on_loading = true;
      if (this.$store.state.core.business_account.account_number !== null) {
        this.loadRequest();
        setInterval(async () => {
          this.loadRequest();
        }, 60000);
      } else {
        this.on_loading = false;
      }
    },
    payProcess(index) {
      if (
        this.selected.filter((element) => element.invoice_outstanding > 0)
          .length > 1
      ) {
        this.open_modal("pay_multiple_factures");
      } else {
        this.open_modal("pay_business_facture");
      }
    },
  },
  watch: {
    "$store.state.core.business_account.account_number"() {
      this.loadLastBills();
    },
  },
};
</script>
<style scoped lang="css">
::v-deep table {
  font-size: 14px !important;
}
::v-deep .table thead th {
  font-weight: 400 !important;
  text-align: left !important;
}
::v-deep td {
  text-align: left !important;
}
::v-deep .badge {
  color: #fff;
  font-weight: 400 !important;
  padding: 4px 8px !important;
  font-size: 10px !important;
}
.paid {
  background: #00b110 !important;
}
.unpaid {
  background-color: #d81822 !important;
}
.pay-link {
  color: #004f71;
  font-size: 14px;
  font-weight: 500 !important;
  cursor: pointer !important;
}
.pay-link:hover,
.pay-link:active {
  color: #013952;
  text-decoration: underline !important;
}
::v-deep tr.b-table-row-selected.table-active {
  background: #ffffff !important;
}
::v-deep
  .table.b-table.b-table-selectable:not(.b-table-selectable-no-click)
  > tbody
  > tr {
  border-bottom: 1px solid #dee2e6;
}
::v-deep .table.b-table.b-table-stacked > tbody > tr > td {
  position: relative;
  height: 50px !important;
  padding-bottom: 0;
  border-bottom: none !important;
}
::v-deep .table.b-table.b-table-stacked > tbody > tr > td .form-check.p-0 {
  position: absolute;
  right: 0.75rem !important;
  top: 0.75rem;
}
::v-deep .table.b-table.b-table-stacked > tbody > tr > td:last-child {
  padding-bottom: 0.75rem !important;
  border-bottom: none !important;
}
::v-deep .table.b-table.b-table-stacked > tbody > tr > :first-child {
  border-top-width: 1px !important;
}
::v-deep .table.b-table.b-table-stacked > tbody > tr > td::before {
  /* text-align: left !important; */
  text-align: right !important;
  /* width: auto !important; */
}
::v-deep .table.b-table.b-table-stacked > tbody > tr > td > div {
  width: auto !important;
  padding-left: 0 !important;
}
.styled-checkbox {
  position: absolute;
  opacity: 0;
}

.styled-checkbox + label {
  position: relative;
  cursor: pointer;
  padding: 0;
  margin: 0 !important;
}

.styled-checkbox + label:before {
  content: "";
  display: inline-block;
  vertical-align: text-top;
  width: 20px;
  height: 20px;
  background: white;
  border: 2px solid #000000;
  border-radius: 50%;
}

.styled-checkbox:hover + label:before {
  background: #ffcc26;
}

.styled-checkbox:focus + label:before {
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.12);
}

.styled-checkbox:checked + label:before {
  background: #ffcc26;
}

.styled-checkbox:disabled + label {
  color: #b8b8b8;
  cursor: auto;
}

.styled-checkbox:disabled + label:before {
  box-shadow: none;
  background: #ddd;
  border: 2px solid #ccc;
}

.styled-checkbox:checked + label:after {
  content: "";
  position: absolute;
  left: 5px;
  top: 9px;
  background: black;
  width: 2px;
  height: 2px;
  box-shadow: 2px 0 0 black, 4px 0 0 black, 4px -2px 0 black, 4px -4px 0 black,
    4px -6px 0 black, 4px -8px 0 black;
  transform: rotate(45deg);
}
#payment_box {
  position: fixed;
  width: calc(100% - 250px) !important;
  left: 250px !important;
  bottom: 0;
  z-index: 10;
  background: #fff;
  padding: 15px;
  box-shadow: 0 -2px 18px rgb(0 0 0 / 30%);
}
.sel-value {
  font-size: 20px;
  font-weight: bold !important;
}
.min-title {
  font-size: 12px !important;
  color: #6c757d !important;
}
.sel-box {
  border-right: 1px solid #f2f2f2;
}
@media only screen and (max-width: 576px) {
  #payment_box {
    width: 100% !important;
    left: 0px !important;
    z-index: 10;
  }
}
</style>
